$(document).ready(function () {  
  
  $('.res-btn').click(function () {
    var header_height = $('#shopify-section-header').innerHeight()
    $('.drawer--left').css({'top':+header_height+'px'});
    $('.doubly-wrapper').css({'float':'unset'})
    $('.doubly-wrapper').show();
    $('.page-container').css({"transform": "translate(0)"})
    $('.site-header').find('.doubly-wrapper').hide();
   });
  
});
